import { gql } from "@apollo/client";

export const WELLNESS_PLAN_EXIST_BY_PET_ID = gql`
query checkWellnessPlanExistByPetId($petId: String!){
  checkWellnessPlanExistByPetId(petId: $petId){
    item{
     wellnessplanData{
      wellnessplanId
      wellnessplanName
      billingInterval
      numberOfBillingCycles
      active
      created_at
      modified_at
      price
      schemaName
    }
    wellnessPlanExist
  }
    success
    messages
  }
}
`;
